import { render, staticRenderFns } from "./subtagmanage.vue?vue&type=template&id=ddb44986&scoped=true&"
import script from "./subtagmanage.vue?vue&type=script&lang=js&"
export * from "./subtagmanage.vue?vue&type=script&lang=js&"
import style0 from "./subtagmanage.vue?vue&type=style&index=0&id=ddb44986&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb44986",
  null
  
)

export default component.exports